function initBaseAnimations() {
	// Options for the IntersectionObserver
	const options = {
		root: null, // Use the viewport as the root
		rootMargin: '0px', // No margin
		threshold: 0.2,
	};

	var del = false;

	// Callback function to handle intersection
	const handleIntersection = (entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {

				let delay = entry.target.dataset.smxanimate;
				if(delay != undefined){
					if (delay.includes('delay-')) {
						var delay_time = parseInt(delay.replace('delay-', ''));
						if (del === false) {
							del = 0;
						} else {
							del += delay_time;
						}
					} else {
						del = false;
					}
				}else{
					del = false;
				}

				if (del != false) {

					setTimeout(function () {
						entry.target.classList.add('is-visible');
					}, del);


				} else {
					entry.target.classList.add('is-visible');
				}
				observer.unobserve(entry.target); // Stop observing once the element is visible
			}
		});
	};

	// Create a new IntersectionObserver
	const observer = new IntersectionObserver(handleIntersection, options);

	// Get all elements with the class 'smx-animate'
	const animatedElements = document.querySelectorAll('.smx-animate');

	// Observe each animated element
	animatedElements.forEach(element => {
		observer.observe(element);
	});
}

// Call the function when the DOM content is loaded
// document.addEventListener('DOMContentLoaded', addVisibleClassToAnimatedElements);

export default { initBaseAnimations }
